<template>
  <div
    id="providers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.code"
                  :rules="[rules.required, rules.alphanumeric, rules.codeLength]"
                  label="Código"
                  maxlength="4"
                  placeholder="0001"
                  @change="searchCode"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.description"
                  :rules="[rules.required]"
                  label="Descripción"
                  placeholder="Casa Matriz"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
               >
                <v-text-field
                  v-model="form.email_address1"
                  :rules="[rules.emailFormat]"
                  label="Correo Electrónico"
                  placeholder="ejemplo@dominio.com"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="form.phone1"
                  :rules="[rules.required, rules.phoneFormat]"
                  label="Teléfono"
                  placeholder="####-#### / ######-####-####"
                  maxlength="16"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="form.phone2"
                  :rules="[rules.phoneFormat]"
                  label="Teléfono Secundario"
                  placeholder="####-#### / ######-####-####"
                  maxlength="16"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="form.postal_code"
                  :rules="[rules.required, rules.numeric, rules.codeLength]"
                  label="Código Postal"
                  maxlength="4"
                  placeholder="0831"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="3">
                <v-select
                  v-model="form.cat_province_id"
                  :items="itemsProvince"
                  item-value="id"
                  item-text="name"
                  :rules="[rules.required]"
                  label="Provincia"
                  required
                  @change="getDistrito()"
                />
              </v-col>
              <v-col
                cols="12"
                md="3">
                <v-select
                  v-model="form.cat_district_id"
                  :items="itemsDistrict"
                  item-value="id"
                  item-text="name"
                  :rules="[rules.required]"
                  label="Distrito"
                  required
                  @change="getCorregimiento()"
                />
              </v-col>
              <v-col
                cols="12"
                md="3">
                <v-select
                  v-model="form.cat_corregimiento_id"
                  :items="itemsCorregimiento"
                  item-value="id"
                  item-text="name"
                  :rules="[rules.required]"
                  label="Corregimiento"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="form.address"
                  maxlength="100"
                  :rules="[rules.required]"
                  label="Dirección"
                  placeholder="Ave. La Paz, entre calles 74A y 75. El Ingenio, Bethania. Ciudad de Panamá"
                  required
                />
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Form from 'vform';
  import { mask } from 'vue-the-mask';
  import FormToolbar from '~/components/Form/Toolbar';

  export default {
    components: {
      FormToolbar,
    },
    directives: {
      mask,
    },
    props: {
      id: { default: '' },
      idSucursal: { default: '' },
      ruc: { default: '' },
    },
    data: () => ({
      form: new Form({
        id: '',
        code: '',
        description: '',
        phone1: '',
        phone2: '',
        address: '',
        postal_code: '',
        cat_corregimiento_id: '',
        cat_district_id: '',
        cat_province_id: '',
        status: '1',
        coordinates: '+8.9892,-79.52010',
        email_address1: '',
        id_cat_country: '139',
        active: '1',
        busy: false,
      }),
      itemsProvince: [],
      itemsDistrict: [],
      itemsCorregimiento: [],
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        alphanumeric: (v) => /^[a-zA-Z0-9]*$/.test(v) || 'El campo solo permite caracteres numéricos.',
        emailFormat: (v) => (!v || /.+@.+\..+/.test(v)) || 'El campo debe tener un correo electrónico válido.',
        phoneFormat: (v) => (
            /^[0-9-]+$/.test(v) && /^(?:\d{3,4}-\d{4}|\d{6}-\d{3,4}-\d{4})$/.test(v)
        ) || 'El campo debe seguir el formato ###-####, ####-####, ######-###-#### o ######-####-####.',
        codeLength: (v) => v.length === 4 || 'El campo debe tener de 4 caracteres numéricos.',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Nueva Sucursal',
      apiURL: '/api/enterprises',
      apiURLSubsidiarie: 'subsidiarie/store',
      method: 'POST',
    }),
    computed: {
      ref() { return this.form.id; },
    },
    watch: {
      'form.cat_province_id': {
        handler() {
          this.getDistrito();
        },
      },
      'form.cat_district_id': {
        handler() {
          this.getCorregimiento();
        },
      },
    },
    async mounted() {
      await this.getProvincia().then((response) => {
        this.itemsProvince = response.data;
      });
      const URL = `${this.apiURL}/${this.id}/${this.apiURLSubsidiarie}`;
      this.URL = URL;
      if (this.idSucursal) {
        window.axios.get(`${this.apiURL}/${this.id}/subsidiarie/${this.idSucursal}`)
        .then((result) => {
          Object.assign(this.form, result.data);
          this.URL = `${this.apiURL}/${this.id}/subsidiarie/${this.idSucursal}/update`;
          this.method = 'PUT';
          this.title = 'Editar Sucursal';
          this.message = `Se ha editado la sucursal ${result.data.name_associate} exitosamente.`;
        });
      }
    },

    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.snackbar = true;
          this.form.busy = true;
          this.store();
        }
      },
      store() {
        window.axios({
          method: this.method,
          url: this.URL,
          data: this.form,
        })
        .then((response) => {
          if (response.data.codigo === 400) {
              this.form.code = '';
              this.form.busy = false;
            } else {
              this.$router.go(-1);
            }
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
      getProvincia() {
        const url = '/api/provinces';
        return window.axios.get(url);
      },
      getDistrito() {
        if (this.form.cat_province_id) {
            const url = `/api/districts/${this.form.cat_province_id}`;
            window.axios.get(url)
            .then((response) => {
            this.itemsDistrict = response.data;
          });
        }
      },
      getCorregimiento() {
        if (this.form.cat_district_id) {
            const url = `/api/corregimientos/${this.form.cat_district_id}`;
            window.axios.get(url)
            .then((response) => {
            this.itemsCorregimiento = response.data;
          });
        }
      },
      searchCode() {
          if (this.form.code) {
            const url = `${this.apiURL}/${this.id}/subsidiarie/getSubsidiary/${this.form.code}`;
            window.axios.get(url)
            .then((response) => {
              if (response.data.codigo === 400) {
                this.form.code = '';
              }
              this.$store.dispatch('notifications/show', {
                message: response.data.message,
                type: response.data.type,
              });
            });
          }
      },
    },
  };

</script>
